import React, { useEffect, useState } from 'react';
import { bool, number, oneOfType, string } from 'prop-types';
import { Image } from '@thd-olt-component-react/image';
import classNames from 'classnames';
import './video-player.scss';

export const VideoPlayer = ({
  autoPlay, className, videoId, videoStill
}) => {
  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('video-player.ready');
  });

  const [enableVideoStill, setEnableVideoStill] = useState(!!videoStill);

  if (enableVideoStill) {
    return (
      <div className="video-player__wrapper video-player__wrapper--still">
        <Image
          alt="thumbnail"
          className="video-player__still"
          height="150"
          width="300"
          src={videoStill}
        />
        <button
          alt="Play Button"
          aria-label="play video"
          className="video-player__play-button"
          onClick={() => setEnableVideoStill(false)}
          type="button"
        />
      </div>
    );
  }

  const classes = classNames('video-player', className);
  let iframeSrc = `https://players.brightcove.net/66036796001/4JE-ofbdg_default/index.html?videoId=${videoId}`;
  iframeSrc += autoPlay || videoStill ? '&autoplay=any&playsinline=true' : '';
  return (
    <div className="video-player__wrapper">
      <iframe
        className={classes}
        src={iframeSrc}
        title={videoId}
        allowFullScreen
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
      />
    </div>
  );

};

VideoPlayer.propTypes = {
  autoPlay: bool,
  className: string,
  videoId: oneOfType([
    string,
    number,
  ]).isRequired,
  videoStill: string
};

VideoPlayer.defaultProps = {
  autoPlay: false,
  className: null,
  videoStill: null
};
